import { render } from "./PdfToolsView.vue?vue&type=template&id=6a2b80c6&scoped=true"
import script from "./PdfToolsView.vue?vue&type=script&lang=js"
export * from "./PdfToolsView.vue?vue&type=script&lang=js"

import "./PdfToolsView.vue?vue&type=style&index=0&id=6a2b80c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a2b80c6"]])

export default __exports__